import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { EntityType } from '../settings/settings.service';

@Injectable({
  providedIn: 'root',
})
export class SettingsHistoryService {
  settingsHistoryUrl: string = environment.settingsHistory;

  constructor(private httpClient: HttpClient) {}

  getDeviceSettingsHistory(
    serialNumber: string,
  ): Promise<SettingsHistoryResult[]> {
    return this.httpClient
      .get<
        SettingsHistoryResult[]
      >(`${this.settingsHistoryUrl}/settingsHistory/device/${serialNumber}`)
      .toPromise();
  }

  getVehicleSettingsHistory(vehicleId: string) {
    return this.httpClient
      .get<
        SettingsHistoryResult[]
      >(`${this.settingsHistoryUrl}/settingsHistory/vehicle/${vehicleId}`)
      .toPromise();
  }

  getGroupSettingsHistory(groupId: string) {
    return this.httpClient
      .get<
        SettingsHistoryResult[]
      >(`${this.settingsHistoryUrl}/settingsHistory/group/${groupId}`)
      .toPromise();
  }

  getStackSettingsHistory(stackId: number) {
    return this.httpClient
      .get<
        SettingsHistoryResult[]
      >(`${this.settingsHistoryUrl}/settingsHistory/root/${stackId}`)
      .toPromise();
  }

  getDefaultSettingsHistory() {
    return this.httpClient
      .get<
        SettingsHistoryResult[]
      >(`${this.settingsHistoryUrl}/settingsHistory/default`)
      .toPromise();
  }
}

export interface SettingsHistoryResult {
  entityId: string;
  entityType: EntityType;
  dataType: DataType;
  updatedDate: string;
  settingName: string;
  settingValue: string;
  userName: string;
  notes: string;
  isLastKnown: boolean;
}

enum DataType {
  boolean = 'Boolean',
  string = 'String',
  int32 = 'Int32',
  int64 = 'Int64',
  decimal = 'Decimal',
}
